import React from "react";

interface ProfileiconProps {
  size?: string;
}
export default function Profileicon(props: ProfileiconProps) {
  const { size = "27" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 27 27"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Navigation-/-Top-/-Logout"
          transform="translate(-1099.000000, -22.000000)"
          stroke="#002035"
          strokeWidth="1.5">
          <g id="Icons-/-Line-/-Profile" transform="translate(1100.000000, 23.000000)">
            <circle id="Oval" cx="12.5" cy="9.056" r="4.516"></circle>
            <path
              d="M21.521,21.152 L21.521,20.689 C21.521,18.0170464 19.3549536,15.851 16.683,15.851 L8.317,15.851 C5.64504638,15.851 3.479,18.0170464 3.479,20.689 L3.479,21.152"
              id="Path"></path>
            <circle id="Oval" cx="12.5" cy="12.5" r="12.5"></circle>
          </g>
        </g>
      </g>
    </svg>
  );
}
